import { call, put, takeLatest } from "redux-saga/effects";
import {
  alcoholAddSuccess,
  alcoholAddFailure,
  alcoholEditSuccess,
  alcoholEditFailure,
  alcoholDeleteSuccess,
  alcoholDeleteFailure,
  alcoholViewSuccess,
  alcoholViewFailure,
  alcoholViewAllSuccess,
  alcoholViewAllFailure,
  alcoholSearchViewAllSuccess,
  alcoholSearchViewAllFailure,
  alcoholPercentageViewSuccess,
  alcoholPercentageViewFailure,
  WholesalerAlcoholPercentageViewSuccess,
  WholesalerAlcoholPercentageViewFailure,
} from "./TypeOfAlcoholAction";

import {
  ALCOHOL_ADD_REQUEST,
  ALCOHOL_EDIT_REQUEST,
  ALCOHOL_DELETE_REQUEST,
  ALCOHOL_VIEW_REQUEST,
  ALCOHOL_VIEW_ALL_REQUEST,
  ALCOHOL_SEARCH_REQUEST,
  ALCOHOL_PERCENTAGE_VIEW_REQUEST,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST,
} from "./TypeOfAlcoholTypes";

import {
  AddAlcoholEffect,
  EditAlcoholEffect,
  DeleteAlcoholEffect,
  ViewAlcoholEffect,
  ViewAllAlcoholsEffect,
  ViewAllSearchAlcoholsEffect,
  ViewAlcoholPercentageEffect,
  ViewWholesalerAlcoholPercentageEffect,
} from "./TypeOfAlcoholEffect";

// Add Alcohol
function* addAlcoholSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(AddAlcoholEffect, action.payload, config);
    yield put(alcoholAddSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "Failed to add alcohol type";
    yield put(alcoholAddFailure({ errormessage: message, errorFields }));
  }
}

// Edit Alcohol
function* editAlcoholSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { alcoholId } = action?.payload;
    const { id, alcohol_type, status } = alcoholId;
    const formData = { alcohol_type, status };

    const response = yield call(EditAlcoholEffect, id, formData, config);
    yield put(alcoholEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "Failed to update alcohol type";
    yield put(alcoholEditFailure({ errormessage: message, errorFields }));
  }
}

// View Alcohol
function* viewAlcoholSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAlcoholEffect, action.payload, config);
    yield put(alcoholViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch alcohol details";
    yield put(alcoholViewFailure({ errormessage: errorMessage }));
  }
}

// View All Alcohols
function* viewAllAlcoholsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllAlcoholsEffect, action.payload, config);
    yield put(alcoholViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch alcohol types";
    yield put(alcoholViewAllFailure({ errormessage: errorMessage }));
  }
}

// View Alcohols Percentage
function* viewAlcoholsPercentageSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAlcoholPercentageEffect,
      action.payload,
      config
    );

    yield put(alcoholPercentageViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch alcohol types";
    yield put(alcoholPercentageViewFailure({ errormessage: errorMessage }));
  }
}

// View Wholesaler Alcohols Percentage
function* viewWholesalerAlcoholsPercentageSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewWholesalerAlcoholPercentageEffect,
      action.payload,
      config
    );

    yield put(WholesalerAlcoholPercentageViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch alcohol types";
    yield put(
      WholesalerAlcoholPercentageViewFailure({ errormessage: errorMessage })
    );
  }
}

// View All Search Alcohols
function* viewAllSearchAlcoholsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllSearchAlcoholsEffect,
      action.payload,
      config
    );

    yield put(alcoholSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch alcohol types";
    yield put(alcoholSearchViewAllFailure({ errormessage: errorMessage }));
  }
}

// Delete Alcohol
function* deleteAlcoholSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(DeleteAlcoholEffect, action.payload, config);
    yield put(alcoholDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete alcohol type";
    yield put(alcoholDeleteFailure({ errormessage: errorMessage }));
  }
}

export function* TypeOfAlcoholSaga() {
  yield takeLatest(ALCOHOL_ADD_REQUEST, addAlcoholSaga);
  yield takeLatest(ALCOHOL_EDIT_REQUEST, editAlcoholSaga);
  yield takeLatest(ALCOHOL_DELETE_REQUEST, deleteAlcoholSaga);
  yield takeLatest(ALCOHOL_VIEW_REQUEST, viewAlcoholSaga);
  yield takeLatest(ALCOHOL_VIEW_ALL_REQUEST, viewAllAlcoholsSaga);
  yield takeLatest(ALCOHOL_PERCENTAGE_VIEW_REQUEST, viewAlcoholsPercentageSaga);
  yield takeLatest(
    WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST,
    viewWholesalerAlcoholsPercentageSaga
  );
  yield takeLatest(ALCOHOL_SEARCH_REQUEST, viewAllSearchAlcoholsSaga);
}
